export class DataUsageEntry {
    public date: string;
    public dataConsumed: number;

}
